var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTxt(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 48,
    viewBox: "0 0 40 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4955_54954)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M27.934 9.85C26.8404 9.84894 25.7918 9.41418 25.0183 8.64106C24.2448 7.86795 23.8095 6.81959 23.808 5.72598V0H5.38198C3.95459 0 2.58564 0.567046 1.57632 1.57637C0.566997 2.58569 0 3.95459 0 5.38198V37.826C0 39.2534 0.566997 40.6223 1.57632 41.6316C2.58564 42.641 3.95459 43.208 5.38198 43.208H27.502C28.9294 43.208 30.2983 42.641 31.3076 41.6316C32.3169 40.6223 32.884 39.2534 32.884 37.826V9.85H27.934Z",
    fill: "#149CCE"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M32.8839 9.85H27.9339C26.8403 9.84894 25.7917 9.41418 25.0182 8.64106C24.2447 7.86795 23.8094 6.81959 23.8079 5.72598V0L32.8839 9.85Z",
    fill: "#149CCE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.1199 16.746H5.46992C5.2717 16.7455 5.08176 16.6665 4.9416 16.5263C4.80144 16.3862 4.72245 16.1962 4.72192 15.998C4.72192 15.7994 4.80065 15.609 4.94087 15.4684C5.08109 15.3278 5.27136 15.2485 5.46992 15.248H26.1199C26.3185 15.2485 26.5088 15.3278 26.649 15.4684C26.7892 15.609 26.8679 15.7994 26.8679 15.998C26.8674 16.1962 26.7884 16.3862 26.6482 16.5263C26.5081 16.6665 26.3181 16.7455 26.1199 16.746Z",
    fill: "#149CCE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.1199 21.22H5.46992C5.2717 21.2195 5.08176 21.1405 4.9416 21.0003C4.80144 20.8602 4.72245 20.6702 4.72192 20.472C4.72192 20.2734 4.80065 20.083 4.94087 19.9424C5.08109 19.8018 5.27136 19.7225 5.46992 19.722H26.1199C26.3185 19.7225 26.5088 19.8018 26.649 19.9424C26.7892 20.083 26.8679 20.2734 26.8679 20.472C26.8674 20.6702 26.7884 20.8602 26.6482 21.0003C26.5081 21.1405 26.3181 21.2195 26.1199 21.22Z",
    fill: "#149CCE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.1199 25.694H5.46992C5.27136 25.6935 5.08109 25.6142 4.94087 25.4736C4.80065 25.333 4.72192 25.1426 4.72192 24.944C4.72245 24.7458 4.80144 24.5558 4.9416 24.4157C5.08176 24.2755 5.2717 24.1965 5.46992 24.196H26.1199C26.3181 24.1965 26.5081 24.2755 26.6482 24.4157C26.7884 24.5558 26.8674 24.7458 26.8679 24.944C26.8679 25.1426 26.7892 25.333 26.649 25.4736C26.5088 25.6142 26.3185 25.6935 26.1199 25.694Z",
    fill: "#149CCE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.1199 30.166H5.46992C5.27154 30.166 5.08129 30.0872 4.94102 29.9469C4.80074 29.8066 4.72192 29.6164 4.72192 29.418C4.72192 29.2194 4.80065 29.029 4.94087 28.8884C5.08109 28.7478 5.27136 28.6685 5.46992 28.668H26.1199C26.3185 28.6685 26.5088 28.7478 26.649 28.8884C26.7892 29.029 26.8679 29.2194 26.8679 29.418C26.8679 29.6164 26.7891 29.8066 26.6488 29.9469C26.5086 30.0872 26.3183 30.166 26.1199 30.166Z",
    fill: "#149CCE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.7879 34.122H11.7799C10.0059 34.122 8.56787 35.5601 8.56787 37.334V44.79C8.56787 46.5639 10.0059 48.002 11.7799 48.002H36.7879C38.5618 48.002 39.9999 46.5639 39.9999 44.79V37.334C39.9999 35.5601 38.5618 34.122 36.7879 34.122Z",
    fill: "#149CCE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.112 42.676V44.13H15.606V42.676H17.112Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.1901 38.116V39.274H20.5561V44.13H19.0941V39.274H17.4761V38.116H22.1901Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.452 44.13L25.1839 42.258L24.0939 44.13H22.4279L24.35 41.034L22.3679 38.116H24.0939L25.3279 39.928L26.3919 38.116H28.05L26.1539 41.144L28.1779 44.13H26.452Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.0599 38.116V39.274H31.4279V44.13H29.9639V39.274H28.3479V38.116H33.0599Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4955_54954"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 48.002,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTxt);
export default __webpack_public_path__ + "static/media/txt.a5bcc1c41809669643000b671e6e3f73.svg";
export { ForwardRef as ReactComponent };